
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, MapPin, Plus } from "lucide-react";

export const SecuritySchedulePage = () => {
  const shifts = [
    {
      id: 1,
      venue: "Club Infinity",
      date: "Tonight",
      time: "10:00 PM - 4:00 AM",
      status: "Confirmed",
      location: "Downtown"
    },
    {
      id: 2,
      venue: "The Basement",
      date: "Tomorrow",
      time: "9:00 PM - 3:00 AM",
      status: "Pending",
      location: "City Center"
    },
    {
      id: 3,
      venue: "Sky Lounge",
      date: "Friday",
      time: "8:00 PM - 2:00 AM",
      status: "Confirmed",
      location: "Uptown"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Calendar className="h-6 w-6 text-purple-400" />
          <h1 className="text-2xl font-bold">Security Schedule</h1>
        </div>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          Request Shift
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="h-5 w-5 text-green-500" />
              <span className="text-sm font-medium">This Week</span>
            </div>
            <p className="text-2xl font-bold">3</p>
            <p className="text-sm text-muted-foreground">Scheduled shifts</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="h-5 w-5 text-blue-500" />
              <span className="text-sm font-medium">Total Hours</span>
            </div>
            <p className="text-2xl font-bold">24</p>
            <p className="text-sm text-muted-foreground">This week</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Badge className="h-5 w-5 text-orange-500" />
              <span className="text-sm font-medium">Pending</span>
            </div>
            <p className="text-2xl font-bold">1</p>
            <p className="text-sm text-muted-foreground">Awaiting confirmation</p>
          </CardContent>
        </Card>
      </div>

      <Card className="glass-card">
        <CardHeader>
          <CardTitle>Upcoming Shifts</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {shifts.map((shift) => (
              <div key={shift.id} className="flex items-center justify-between p-4 border rounded-lg">
                <div className="flex items-center gap-4">
                  <div>
                    <p className="font-medium">{shift.venue}</p>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Calendar className="h-4 w-4" />
                      <span>{shift.date}</span>
                      <Clock className="h-4 w-4 ml-2" />
                      <span>{shift.time}</span>
                      <MapPin className="h-4 w-4 ml-2" />
                      <span>{shift.location}</span>
                    </div>
                  </div>
                </div>
                <Badge variant={shift.status === "Confirmed" ? "default" : "secondary"}>
                  {shift.status}
                </Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card className="glass-card">
        <CardHeader>
          <CardTitle>Calendar View</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-64 flex items-center justify-center text-muted-foreground">
            <p>Calendar component placeholder - would show monthly schedule view</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
